$(function() {
	// CHAGE ROW COLOR OF SPARE ADDED PART
		$('.submit_party_followup_filter').change(function(){
			document.getElementById("filter_party_followup").submit()	;
		});
});